function FieldUpdater($el) {
    this.$el = $el;
    this.$display = this.$el.find('.display');
    this.$edit = this.$el.find('.edit').hide();
    this.events();
}

FieldUpdater.prototype.events = function(){
    var self = this;

    this.$el.on('click', '.fa-cog', function(){
        self.edit();
    }).on('click', '.fa-save', function(){
        self.save();
    });
}

FieldUpdater.prototype.edit = function() {
    this.$edit.show();
    this.$display.hide();
}

FieldUpdater.prototype.save = function() {
    var self = this;
console.log('save');
console.log({
    id: this.$el.data('id'),
    model: this.$el.data('model'),
    field: this.$el.data('field'),
    value: this.$el.find('input').val()
});
    $.ajax({
        method: 'POST',
        url: '/fields/update',
        data: {
            id: this.$el.data('id'),
            model: this.$el.data('model'),
            field: this.$el.data('field'),
            value: this.$el.find('input').val()
        }
    }).done(function( msg ) {
        if(msg.success) {
            self.$display.find('.value').text(self.$el.find('input').val());
            self.$edit.hide();
            self.$display.show();
        } else {
            alert('Oops, something went wrong!');
        }
    });
}

$(document).ready(function(){
    var $updaters = $('[data-updateable-field]');
    $updaters.each(function(){
        new FieldUpdater($(this));
    });
});
